import { NgModule } from 'ng-metadata/core';

ngAnimateConfig.$inject = ['$animateProvider'];
export function ngAnimateConfig($animateProvider) {
  $animateProvider.classNameFilter(/\bng-animated\b/);
}



// WEBPACK FOOTER //
// ./resources/assets/js/config/animate.config.ts